import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import DashboardHeader from "./HeaderDashboard"
import { getRandomBackground } from "../../utils/imageutils"
import StudyCard from "../ui/cards/studyCard"
import CreateStudyCard from "../ui/cards/CreateStudyCard"
import NoStudiesCard from "../ui/cards/NoStudyCard"
import StudyController from "@/network/controllers/study.controller"
import { useSession } from "@hooks/useSession"
import State,{ STATE, CurrentEntityState } from "@state"

export default function CRODashboard() {
  const navigate = useNavigate()
  const { user } = useSession()

  const [activeFilter, setActiveFilter] = useState("Ongoing studies")
  const [studies, setStudies] = useState([])
  const [createCardBg, setCreateCardBg] = useState("")
  const [allStudies, setAllStudies] = useState([])
  const [entityId, setEntityId] = useState(STATE[CurrentEntityState.CURRENT_ENTITY_ID]||"")


  useEffect(() => {
    setCreateCardBg(getRandomBackground())
  }, [])

  useEffect(() => {
    const handleEntityIdChange = (newValue) => {
      console.log("Listener triggered: ROLE_CONTEXT changed to", newValue)
      setEntityId(newValue)
    }
    State.registerListener(CurrentEntityState.CURRENT_ENTITY_ID, handleEntityIdChange);
    return () => {
      State.unregisterListener(CurrentEntityState.CURRENT_ENTITY_ID, handleEntityIdChange);
    };
  }, []);
    

  useEffect(() => {
    console.log('=== entityId === CRODashboard.jsx === key: 447363 ===');
    console.dir(entityId, { depth: null, colors: true })
    console.log('=================================');
    const fetchAllStudies = async () => {
      const currentEntityId = entityId

      if (!currentEntityId) {
        console.warn("ID pas disponible, impossible recuperé les etudes .")
        return
      }
      console.log("Fetching studies for Entity ID from session:", currentEntityId)
      const response = await StudyController.getStudiesByEntityId(currentEntityId)
      console.log("=== response === CRODashboard.jsx === key: 444728 ===")
      console.dir(response, { depth: null }) 
      console.log("=================================")
      if (response && Array.isArray(response)) {
        setAllStudies(response)
      } else {
        console.error("Failed to fetch studies or response format is incorrect:", response)
        setAllStudies([])
      }
    }

    if (entityId) {
      fetchAllStudies()
    }
  }, [entityId]) 

/** ------------------ cmt 005899 ------------------
  useEffect(() => {
    const fetchAllStudies = async () => {
      const currentUserId = user?.userId

      if (!currentUserId) {
        console.warn("ID pas disponible, impossible recuperé les etudes .")
        return
      }
      console.log("Fetching studies for User ID from session:", currentUserId)
      const response = await StudyController.getStudiesByUserId(currentUserId)
      console.log("=== response === CRODashboard.jsx === key: 444728 ===")
      console.dir(response, { depth: null }) 
      console.log("=================================")
      if (response && Array.isArray(response)) {
        setAllStudies(response)
      } else {
        console.error("Failed to fetch studies or response format is incorrect:", response)
        setAllStudies([])
      }
    }

    if (user?.userId) {
      fetchAllStudies()
    }
  }, [user?.userId]) 
*-------------------------------------------------*/

  useEffect(() => {
    let filtered = []
    if (allStudies.length > 0) {
      switch (activeFilter) {
        case "Ongoing studies":
          filtered = allStudies.filter((study) => study.status === "started")
          break
        case "Created studies":
          filtered = allStudies
          break
        case "Closed studies":
          filtered = allStudies.filter((study) => study.status === "closed")
          break
        case "Managed studies":
          filtered = allStudies
          break
        default:
          filtered = allStudies
      }
    }
    setStudies(filtered)
  }, [activeFilter, allStudies])

  const filterButtons = ["Ongoing studies", /* "Created studies", "Managed studies", */ "Closed studies"]

  const handleCreateStudy = () => {
    navigate("/create-study")
  }

  const handleFilterChange = (filterName) => {
    setActiveFilter(filterName)
  }

  const handleViewStudy = (studyId, studyTitle) => {
    navigate(`/study/${studyId}`, { state: { studyTitle: studyTitle } })
  }

  const getSectionTitle = () => {
    switch (activeFilter) {
      case "Ongoing studies":
        return "All studies"
      case "Created studies":
        return "My studies"
      case "Managed studies":
        return "Managed studies"
      case "Closed studies":
        return "Closed studies"
      default:
        return "All studies"
    }
  }

  const showCreateStudyCard = allStudies.length === 0
  const noStudiesForCurrentFilter = studies.length === 0 && !showCreateStudyCard

  return (
    <div className="flex-1 flex flex-col overflow-hidden p-4 md:p-6 lg:p-8">
      <DashboardHeader
        title="Dashboard"
        buttons={filterButtons}
        activeButton={activeFilter}
        onButtonClick={handleFilterChange}
      />
      <div className="flex-1 mt-2 rounded-xl bg-dashboard-bg1">
      <main className="p-3 sm:p-4 md:p-6 overflow-y-auto h-[calc(100vh-8rem)]">
      <h2 className="text-lg font-semibold mb-4 md:mb-6">{getSectionTitle()}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-4 2xl:gap-6">
            {showCreateStudyCard && <CreateStudyCard backgroundImage={createCardBg} onClick={handleCreateStudy} />}
            {noStudiesForCurrentFilter && <NoStudiesCard />}
            {studies.map((study) => {
              const randomBgImage = getRandomBackground()
              const cardVariant = study.status === "closed" ? "closed" : "cro"

              const studyData = {
                ...study,
                name: study.title, 
                createdBy: study.created_by,
                createdAt: study.created_at,
                updatedAt: study.last_modified,
                lastTraceability: study.last_traceability,
              }

              return (
                <StudyCard
                  className="max-w-[340px]"
                  key={study.id}
                  study={studyData}
                  backgroundImage={randomBgImage}
                  onClick={() => handleViewStudy(study.id, studyData.name)} 
                  variant={cardVariant}
                />
              )
            })}
          </div>
        </main>
      </div>
    </div>
  )
}